import { render, staticRenderFns } from "./FeatureIcons.vue?vue&type=template&id=2d68be58&"
import script from "./FeatureIcons.vue?vue&type=script&lang=js&"
export * from "./FeatureIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports